import { ref, unref, watch } from '@vue/composition-api'
import TicketService from '@/services/modules/TicketService'
import { EventBus } from '@/utils/EventBus'

export default function useTicketSlas(ticketId) {
  const slas = ref([])

  async function getSlasTicket() {
    if (!unref(ticketId)) {
      slas.value = []
      return
    }

    slas.value = await TicketService.getSlasTicket(unref(ticketId))
  }

  watch(ticketId, getSlasTicket, { immediate: true })

  EventBus.$on('refetch-ticket-slas', getSlasTicket)

  return {
    slas,
    getSlasTicket,
  }
}
